import { useHistory, useParams } from "react-router";
import React from "react";
import { ETLCodes } from "../../../../locales";
import { PageBase, BackButton, ProtectedTabs } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { ClubRoleDetailPage } from "..";
import { useTl, useApiService } from "../../../../hooks";
import { ClubRoleApi } from "../../../../api";
import { useGlobalData } from "../../../../contexts";
import {useApiEffect} from "nsitools-react";

export interface IClubRoleItemPageProps {}

export const ClubRoleItemPage: React.FunctionComponent<IClubRoleItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const idClubRole = React.useMemo(() => +id, [id]);
  const { currentLanguage } = useGlobalData();
  const api = useApiService(ClubRoleApi);
  const history = useHistory();
  const [displayName, loading] = useApiEffect(
    () => api.getDisplayName(idClubRole, currentLanguage.languageCode),
    [idClubRole],
  );

  return (
    <>
      <PageBase
        breadCrumbs={[
          { text: t(ETLCodes.ClubRoles), route: ERoutes.clubRoles },
          { text: idClubRole > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
        ]}
      >
        <ProtectedTabs
          id="TabsClubRole"
          onChange={(newTabId) => history.push(`${ERoutes.clubRoles}/${id}/${newTabId}/${state}`)}
          selectedTabId={tab}
          renderActiveTabPanelOnly
        >
          <BackButton backRoute={ERoutes.clubRoles} />
          <Tab
            id="detail"
            title={t(ETLCodes.Detail)}
            panel={<ClubRoleDetailPage idClubRole={idClubRole} editMode={state === "edit"} />}
          />
        </ProtectedTabs>
      </PageBase>
    </>
  );
};
